<div mat-dialog-title>
  <div class="d-flex justify-content-between">
    <p>Create Message</p>
    <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content class="m-0">
  <app-create-communication></app-create-communication>
</div>
